class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul')
    };
    
    // Toggle dropdown on button click
    this.elements.button.addEventListener('click', (event) => {
      event.stopPropagation();
      this.toggleDropdown();
    });
    
    // Close when clicking outside
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.closeDropdown();
      }
    });
    
    // Handle item clicks
    this.querySelectorAll('a').forEach(item => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.elements.input.value = event.currentTarget.dataset.value;
        this.querySelector('form').submit();
      });
    });
  }

  toggleDropdown() {
    const isOpen = this.elements.button.getAttribute('aria-expanded') === 'true';
    this.elements.button.setAttribute('aria-expanded', (!isOpen).toString());
    this.elements.panel.toggleAttribute('hidden');
  }

  closeDropdown() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', '');
  }
}

customElements.define('localization-form', LocalizationForm);